import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Symptoms } from "./components/Symptoms";
import { AIQuiz } from "./components/AIQuiz";
import { HowItWorks } from "./components/HowItWorks";
import { Pricing } from "./components/Pricing";
import { AboutDoctor } from "./components/AboutDoctor";
import { Reviews } from "./components/Reviews";
import { FAQ } from "./components/FAQ";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { WhatsAppFAB } from "./components/WhatsAppFAB";
import { Nesa } from "./components/Nesa";
import { Treatments } from "./components/Treatments";

const Home = () => (
  <>
    <Header />
    <main data-testid="main-content">
      <Hero />
      <Symptoms />
      <AIQuiz />
      <HowItWorks />
      <Treatments />
      <Nesa />
      <Pricing />
      <AboutDoctor />
      <Reviews />
      <FAQ />
      <Contact />
    </main>
    <Footer />
    <WhatsAppFAB />
  </>
);

function App() {
  return (
    <div className="App">
      <Toaster position="bottom-center" richColors closeButton />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
